import QK from '@opsbase/lib-data-queryfield/QueryFieldKey';
import DataType from '@opsbase/lib-datatype/DataType';
import Event from '@opsbase/lib-event';
import Pages from '@opsbase/lib-pages';
import AppPage from '@opsbase/web-app/AppPage';
import useView from '@opsbase/web-ctrl-view/useView';
import DVLPage from '@opsbase/web-dvl-page';
import React from 'react';
import WorkflowSelectionToolbar from '../toolbars/WorkflowSelectionToolbar';
export function OpsBusinessRulesPage() {
    const view = useView(DataType.WORKFLOW);
    view.filters = [
        ...view.filters,
        {
            queryFieldKey: QK.WORKFLOW_EVENT,
            id: Event.ISSUE_COMMENT,
            hidden: true,
            veryHidden: true,
        },
        {
            queryFieldKey: QK.WORKFLOW_EVENT,
            id: Event.ISSUE_STATUS_CHANGED,
            hidden: true,
            veryHidden: true,
        },
        {
            queryFieldKey: QK.WORKFLOW_EVENT,
            id: Event.ISSUE_MISSED,
            hidden: true,
            veryHidden: true,
        },
        {
            queryFieldKey: QK.WORKFLOW_EVENT,
            id: Event.ISSUE_ASSIGNED,
            hidden: true,
            veryHidden: true,
        },
        {
            queryFieldKey: QK.WORKFLOW_EVENT,
            id: Event.ISSUE_CREATED,
            hidden: true,
            veryHidden: true,
        },
        {
            queryFieldKey: QK.WORKFLOW_EVENT,
            id: Event.ISSUE_CLOSED,
            hidden: true,
            veryHidden: true,
        },
    ];
    return (React.createElement(AppPage, null,
        React.createElement(DVLPage, { viewId: DataType.WORKFLOW, itemPage: Pages.WORKFLOWS_EDIT, itemCreatePage: Pages.WORKFLOWS_PICKTRIGGER, itemDeletePage: Pages.WORKFLOWS_DELETE, itemSelectionToolbar: React.createElement(WorkflowSelectionToolbar, null) })));
}
export default OpsBusinessRulesPage;
